import distance from '@turf/distance';
import { LatLng } from 'shared/types';

export const getMarkerMoveDistanceMiles = (
  original: LatLng | null,
  current: LatLng | null,
): number =>
  !original || !current
    ? 0
    : distance([original.lng, original.lat], [current.lng, current.lat], {
        units: 'miles',
      });
